import React, {Fragment} from 'react';
import {logoutUser} from '../../actions';
import connect from "react-redux/es/connect/connect";
import classNames from "classnames";
import Modal from "./Modal";
import TextInput from "../form/TextInput";
import Portal from "./Portal";
import {sendRequest} from "../../utils/request";
import Icon from "../form/Icon";

/*let time = null;

window.blur = () => {
    time = new Date().getTime();
};
window.focus = () => {
    if (time !== null && time + 3600000 < new Date().getTime()) {
        window.location.reload(true);
    } else {
        time = null;
    }
};*/

const RefreshButton = () => {
    return <a href="#" className="btn btn-default btn-flat" onClick={(e) => {
        e && e.preventDefault();
        window.location.reload(true);
    }}><Icon lib="fa" name="refresh" /></a>;
}

class MainUserMenu extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            opened: props.opened !== undefined ? props.opened : false,
            debug: null,
            disabled: false
        };
    }

    toggle = (e) => {
        e.preventDefault();
        this.setState({opened: !this.state.opened});
    }

    render() {
        const user = this.props.user;
        return <li className={classNames("dropdown user user-menu", {open: this.state.opened})}>
            <a href="" onClick={this.toggle} className="dropdown-toggle" data-toggle="dropdown" aria-expanded="true">
                <span>{user.name}</span>
            </a>
            <ul className="dropdown-menu">
                <li className="user-header">
                    <p>
                        {user.name}
                        <small>{user.email}</small>
                    </p>
                </li>
                <li className="user-footer">
                    <div className="pull-left">
                        <RefreshButton />
                    </div>
                    <div className="pull-right">
                        {window.location.hostname === "localhost" &&
                        <Fragment>
                            <Portal>
                                <Modal
                                    header="debug_password"
                                    ref={(debugModal) => this.debugModal = debugModal}
                                    disabled={this.state.disabled}
                                    buttons={[
                                        {
                                            text: "Mégse",
                                            props: {color: "default", disabled: this.state.disabled},
                                            onClose: true,
                                            onClick: () => {
                                                this.debugModal && this.debugModal.hide();
                                            }
                                        },
                                        {
                                            text: "Debug",
                                            props: {color: "primary", disabled: this.state.disabled},
                                            onClose: true,
                                            onClick: async () => {
                                                this.setState({disabled: true}, async () => {
                                                    await sendRequest({debug: this.state.debug});
                                                    this.debugModal && this.debugModal.hide();
                                                    this.setState({disabled: false});
                                                });
                                            }
                                        }
                                    ]}
                                >
                                    <TextInput name="debug" label={false} saveChanges={(field, debug) => this.setState({debug})}/>
                                </Modal>
                            </Portal>
                            <a className="btn btn-warning btn-flat" onClick={(e) => {
                                e && e.preventDefault();
                                this.debugModal && this.debugModal.focus();
                            }}>
                                Debug
                            </a>
                        </Fragment>}
                        <a href="#" className="btn btn-default btn-flat" onClick={(e) => {
                            e && e.preventDefault();
                            this.props.logoutUser();
                        }}>Kijelentkezés</a>
                    </div>
                </li>
            </ul>
        </li>;
    }
}

export default connect((state) => { return {user: state.app.user}}, {logoutUser})(MainUserMenu);